<template>
     <el-dialog title="添加职位用户" :visible.sync="addPositionUserDialog" width="25%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDialog" :show-close= false>
        <el-card>
            <el-form  :model="request" label-width="80px">
                <el-form-item label="账号" required=true><el-input v-model="request.account" clearable style="width: 250px" placeholder="手机号或者邮箱"></el-input></el-form-item>
                <el-form-item label="性别" required=true>
                    <el-radio-group v-model="request.gender" @change="changeGender">
                        <el-radio label="0">男</el-radio>
                        <el-radio label="1">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="姓名" required=true><el-input v-model="request.name" clearable style="width: 250px" placeholder="真实名称"></el-input></el-form-item>
                <el-form-item label="职位" required=true>
                    <el-select v-model="request.positionId" placeholder="请选择职位"  clearable style="width: 250px">
                        <el-option v-for="item in positions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="addPositionUserDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="addPositionUser">确定</el-button>
        </span>
     </el-dialog>
</template>
<script>
import {getPosition,addPcManager} from '../../api/sys/pcManager.js'
export default {
    data(){
        return {
            addPositionUserDialog: false,
            request: {
                account: '',
                name: '',
                gender: '0',
                genderStr: '男',
                positionId: ''
            },
            positions: [],
        }
    },
    methods: {
        init(){
            this.addPositionUserDialog = true;
            //获取权限列表
            getPosition().then(result=>{
                this.positions = result.data;
            })
        },
        addPositionUser(){
            if(this.request.account === null || this.request.account === ""){
                this.$message({
                    message: "账号不能为空",
                    type: "error",
                    duration: 1500,
                });
                return;
            }
            if(this.request.name === null || this.request.name === ""){
                this.$message({
                    message: "姓名不能为空",
                    type: "error",
                    duration: 1500,
                });
                return;
            }
            if(this.request.positionId === null || this.request.positionId === ""){
                this.$message({
                    message: "职位不能为空",
                    type: "error",
                    duration: 1500,
                });
                return;
            }
            console.log(this.request);
            addPcManager(this.request).then(result=>{
                this.$emit("add-succeed");
                this.$message({
                    message: "添加成功",
                    type: "success",
                    duration: 1500,
                });
                this.addPositionUserDialog = false;
            });
            
        },
        changeGender(value){
            if(value === "0"){
                this.request.genderStr = "男";
            }else{
                this.request.genderStr = "女";
            }
        },
        closeDialog(){
            this.addPositionUserDialog =  false;
            this.request.account = "";
            this.request.name = "";
            this.request.gender = "0";
            this.request.genderStr = "男";
            this.request.positionId = "";
            this.positions = [];
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/sys/addManager.vue